import classNames from "classnames";
import React from "react";

import { useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";

import "./Drawer.scss";

interface DrawerPropsI {
	children: React.ReactNode;
}

export const Drawer = ({ children }: DrawerPropsI) => {
	const isVisible = useSelector((state) => state.popup.products.isVisible);

	return (
		<div
			tabIndex={0}
			aria-label={strings.popupAddToCart}
			className={classNames({
				"addtocart-drawer-container": true,
				caas: true,
				"show-element": isVisible,
			})}
		>
			{isVisible && children}
		</div>
	);
};
